/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_Filteritems1Inputs */

const id_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter item...`)
};

const ms_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapis item...`)
};

const da_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrér items...`)
};

const de_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items filtern...`)
};

const en_us2_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items...`)
};

const es_es2_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar items...`)
};

const es_mx2_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar ítems...`)
};

const fil_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-filter ang mga item...`)
};

const fr_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer les items…`)
};

const it_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra articoli...`)
};

const hu_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek szűrése...`)
};

const nl_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items...`)
};

const no_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer elementer...`)
};

const pl_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtruj elementy...`)
};

const pt_br2_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items...`)
};

const pt_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar itens...`)
};

const ro_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrează elementele...`)
};

const fi_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suodata kohteita...`)
};

const sv_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrera objekt...`)
};

const vi_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc mục...`)
};

const tr_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeleri filtrele...`)
};

const cs_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrovat položky...`)
};

const bg_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Филтриране на обекти...`)
};

const ru_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр объектов...`)
};

const uk_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фільтрувати елементи...`)
};

const ar_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفية العناصر...`)
};

const hi_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम फ़िल्टर करें...`)
};

const th_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรองรายการ...`)
};

const ja_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムをフィルター...`)
};

const zh_cn2_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items...`)
};

const zh_hant1_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items...`)
};

const ko_table_toolbar_filteritems1 = /** @type {(inputs: Table_Toolbar_Filteritems1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items...`)
};

/**
* | output |
* | --- |
* | "Filter items..." |
*
* @param {Table_Toolbar_Filteritems1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_filteritems1 = /** @type {((inputs?: Table_Toolbar_Filteritems1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_Filteritems1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_filteritems1(inputs)
	if (locale === "ms") return ms_table_toolbar_filteritems1(inputs)
	if (locale === "da") return da_table_toolbar_filteritems1(inputs)
	if (locale === "de") return de_table_toolbar_filteritems1(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_filteritems1(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_filteritems1(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_filteritems1(inputs)
	if (locale === "fil") return fil_table_toolbar_filteritems1(inputs)
	if (locale === "fr") return fr_table_toolbar_filteritems1(inputs)
	if (locale === "it") return it_table_toolbar_filteritems1(inputs)
	if (locale === "hu") return hu_table_toolbar_filteritems1(inputs)
	if (locale === "nl") return nl_table_toolbar_filteritems1(inputs)
	if (locale === "no") return no_table_toolbar_filteritems1(inputs)
	if (locale === "pl") return pl_table_toolbar_filteritems1(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_filteritems1(inputs)
	if (locale === "pt") return pt_table_toolbar_filteritems1(inputs)
	if (locale === "ro") return ro_table_toolbar_filteritems1(inputs)
	if (locale === "fi") return fi_table_toolbar_filteritems1(inputs)
	if (locale === "sv") return sv_table_toolbar_filteritems1(inputs)
	if (locale === "vi") return vi_table_toolbar_filteritems1(inputs)
	if (locale === "tr") return tr_table_toolbar_filteritems1(inputs)
	if (locale === "cs") return cs_table_toolbar_filteritems1(inputs)
	if (locale === "bg") return bg_table_toolbar_filteritems1(inputs)
	if (locale === "ru") return ru_table_toolbar_filteritems1(inputs)
	if (locale === "uk") return uk_table_toolbar_filteritems1(inputs)
	if (locale === "ar") return ar_table_toolbar_filteritems1(inputs)
	if (locale === "hi") return hi_table_toolbar_filteritems1(inputs)
	if (locale === "th") return th_table_toolbar_filteritems1(inputs)
	if (locale === "ja") return ja_table_toolbar_filteritems1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_filteritems1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_filteritems1(inputs)
	return ko_table_toolbar_filteritems1(inputs)
});
export { table_toolbar_filteritems1 as "table.toolbar.filterItems" }